export enum YesNo {
    YES = 'Yes',
    NO = 'No',
}
